import { useEffect } from 'react';

import { useSuggestionsContext } from '@components/suggestions/context/useSuggestionsContext';
import { QuickActionFunctionType } from '@components/suggestions/quickActions/types';

const useSetAction = (
  actionFunction: () => Promise<QuickActionFunctionType>,
  index: number,
  isDisabled: boolean
) => {
  const { setActionFunction, setDisabled } = useSuggestionsContext();

  useEffect(() => {
    if (index === 0) {
      // Only set action function if top quick action
      setActionFunction(actionFunction);
    }
  }, [index, setActionFunction, actionFunction]);

  useEffect(() => {
    if (index === 0) {
      // Only set disabled if top quick action
      setDisabled(isDisabled);
    }
  }, [index, setDisabled, isDisabled]);

  return {
    setActionFunction,
    setDisabled
  };
};

export default useSetAction;
